module.exports = __webpack_public_path__ + "static/img/icon_hzi.ac9f2909.png";